import {
  CacheStrategy,
  State
} from '@vodacom/web-state';

import {
  Environment
} from '@vodacom/web-env';

import {
  Messages,
  resolveResponseToProviderResult
} from '@vodacom/web-common';

import {
  Environments
} from '@vodacombusiness/web-vb-common';

export class WebAssetService {

  static baseUrl = (
      Environment.current.name === 'Local'
          ? `${Environments.Dev.uiHost}`
          : ''
  );

  static state = State.with('WebAssetService', this.baseUrl);

  static async getHeaderFragment() {

    try {

      const res = await WebAssetService.state.fetch(
          '/fragment-header', {
            method: 'GET',
            strategy: CacheStrategy.None
          }
      );

      return resolveResponseToProviderResult(
          res,
          Messages.DefaultError
      );

    } catch (e) {

      return {
        ok: false,
        error: e,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }
  }
}
